import type { IAltText } from "../photo-gallery/types/photo-gallery.types";

export const defaultListingAltText = ({
  title,
  city,
  state,
  neighborhood,
  intl,
}: IAltText): string => {
  if (!state) {
    return intl.formatMessage(
      {
        id: "listing.listing_hero.image_no_state",
        defaultMessage: "{pageTitle} Image in {neighborhood}, {city}",
      },
      {
        pageTitle: title,
        neighborhood: neighborhood,
        city: city,
      },
    );
  }

  return intl.formatMessage(
    {
      id: "listing.listing_hero.image",
      defaultMessage: "{pageTitle} Image in {neighborhood}, {city}, {state}",
    },
    {
      pageTitle: title,
      neighborhood: neighborhood,
      city: city,
      state: state,
    },
  );
};
